import { InjectionToken } from '@angular/core';
import { Observable, EMPTY } from 'rxjs';
import { QueryCriteria } from '../../filters';

type DataObject = Record<string, unknown>;

export interface FilterOptionService {
  get searchParams(): DataObject;
  clearNullFilter$: Observable<void>;
  searchQuery(filters: QueryCriteria[]): void;
  clearNullFilters(): void;
}

export const NoopFilterOptionService: FilterOptionService = {
  get searchParams(): DataObject {
    return { filters: [] };
  },
  clearNullFilter$: EMPTY as Observable<void>,
  searchQuery(): void {},
  clearNullFilters(): void {},
};

export const FILTER_OPTION_SERVICE_TOKEN = new InjectionToken<FilterOptionService>('FILTER_OPTION_SERVICE');
